// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__giq2U","clinicsSelect":"styles_clinicsSelect__2zIRF"};